export const smartDocParamType_EHR = 'ehr';
export const smartDocEHRParam_EHRType_Epic = 'epic';
export const smartDocEHRParam_EHRTypes = [smartDocEHRParam_EHRType_Epic];
//# sourceMappingURL=types.js.map